export default __webpack_public_path__ + "static/media/Asset 9r.7e7955e0.svg";